import React, { useState, useMemo } from "react";
import { Modal, DatePicker, Typography } from "antd";
import moment from "moment";

const { Text } = Typography;

export default function BatchModify({
  visible,
  selectedRow,
  onCancel,
  onConfirm,
}) {
  // 默认日期：今天
  const [expireDate, setExpireDate] = useState(null);

  // 禁用今天之前的日期
  const disabledDate = (date) => {
    return date && date < moment().subtract(1, 'day').startOf("day");
  };

  // 剩余逻辑:
  // 1. 全部相同
  // 2. 存在不同
  // 3. 部分已经被冻结
  const desc = useMemo(() => {
    if (selectedRow.length === 0) return false
    
    const frozenRows = selectedRow.filter(item => item.is_freeze)
    const firstDate = selectedRow[0].expired_at
    console.log(selectedRow, 'selectedRow')
    console.log(firstDate, 'firstDate')
    const allSame = selectedRow.every(item => item.expired_at === firstDate)
    console.log(allSame, 'allSame')
    const start = <>当前已选中 {selectedRow.length} 个学员账户</>
    const fronzeTips = frozenRows.length > 0 && (
       <>，<b strong>其中有 {frozenRows.length} 个学员已经被冻结</b></>
     )
    if (allSame) {
       return <>{start}
          ，他{selectedRow.length > 1 ? '们' : ''}目前的有效期{selectedRow.length > 1 ? '均' : ''}
          {firstDate ? `是到 ${new Date(firstDate).toLocaleDateString()}` : '未设置'}
          {fronzeTips}, 是否{selectedRow.length > 1 ? '批量' : ''}修订其有效期？
        </>
    } else {
     return <>{start}
        ，他们的有效期各不相同
        {frozenRows.length === 0 ? (
          <>，<b>其中最接近到期的是 {findClosestDate(selectedRow.map(item => item.expired_at), moment())}</b></>
        ): fronzeTips}
        ，是否批量修订，使他们的账户有效截止日期相同?
      </>
    }
  }, [selectedRow])
  return (
    <Modal
      title="批量修订学员账户的有效期"
      visible={visible}
      onCancel={onCancel}
      afterClose={() => {
        setExpireDate(null); // 清空 DatePicker
        onCancel();
      }}
      onOk={() => onConfirm(expireDate)}
      okText="修订"
      cancelText="取消"
    >
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>

        <Text>
          {desc}
        </Text>

        <div style={{ marginTop: 8 }}>
          <Text strong style={{ marginRight: 8 }}>
            <i style={{ color: 'red' }}>*</i> 账户有效期至
          </Text>

          <DatePicker
            value={expireDate}
            onChange={(d) => setExpireDate(d)}
            disabledDate={disabledDate}
            format="YYYY/MM/DD"
          />
        </div>

        <Text type="secondary">
          到期后学生账户会被冻结，需要本校区管理员将其重新解冻方可再次登录
        </Text>

      </div>
    </Modal>
  );
}


function findClosestDate(dateList, targetDate) {
  if (!dateList.length || !targetDate) return
  let minDiff = Infinity;
  let closest = null
  for (const d of dateList) {
    const diff = Math.abs(new Date(d).getTime() - new Date(targetDate).getTime())
    if (diff < minDiff) {
      minDiff = diff
      closest = d
    }
  }
  if (closest) {
    return new Date(closest).toLocaleDateString()
  }
  return closest
}
